/**
 * Fills a format string with given parameters
 */
export function format(formatString) {
    var params = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        params[_i - 1] = arguments[_i];
    }
    if (!formatString) {
        return formatString;
    }
    var replacedFormatString = formatString;
    var _loop_1 = function (i) {
        var regex = new RegExp('\\{' + i + '\\}', 'gi');
        replacedFormatString = replacedFormatString.replace(regex, function () { return params[i]; });
    };
    for (var i = 0; i < params.length; i++) {
        _loop_1(i);
    }
    return replacedFormatString;
}
//# sourceMappingURL=format.js.map